<div [class.integrated]="integrated" class="se-container">
    <div class="se-content">
        <ecg-header-information
            [hidden]="chart?.layers.length !== 1 || !ecgState.viewerState.toolbarVisible"
            [layer]="chart?.activeLayer"
            class="information"
        ></ecg-header-information>

        <div class="innercontent">
            <div [hidden]="layers?.length <= 1">
                <se-checkedlistbox class="studies" title="{{ 'STUDIES' | translate }}">
                    <se-checkeditem
                        (activeChange)="activateLayer(layer)"
                        (selectedChange)="selectLayer(layer)"
                        *ngFor="let layer of layers"
                        [active]="layer.active"
                        [description]="layer.study?.dateTime | datetime: 'dd/MM/yyyy HH:mm'"
                        [selected]="layer.selected"
                        [title]="layer.patient?.lastName + ' ' + layer.patient?.firstName"
                    >
                    </se-checkeditem>
                </se-checkedlistbox>
            </div>
            <ecg-viewer [chart]="chart" [ecgConfiguration]="ecgConfiguration" [ecgState]="ecgState" class="viewer">
            </ecg-viewer>
        </div>
    </div>
</div>
